import { getErrorFromObject } from '../logging/genericInformationLogging';
import {
    createGroupSite,
    CreateGroupSiteResponse,
    GroupSiteStatus,
} from 'owa-groups-sharepoint-commands';
import { PerformanceDatapoint, DatapointStatus } from 'owa-analytics';
import { delay } from '../utils/addDelay';

const MAX_POLLING_TIMES = 5;
const POLL_DELAY_IN_MSEC = 500;

export default async function pollGroupSiteCreation(
    groupSiteRootUrl: string,
    groupExternalDirectoryObjectId: string
): Promise<CreateGroupSiteResponse> {
    const datapoint = new PerformanceDatapoint('GroupFilesHubPollGroupSiteCreationDP');

    for (let i = 0; i < MAX_POLLING_TIMES; i++) {
        try {
            const createGroupSiteResponse = await createGroupSite(
                groupSiteRootUrl,
                groupExternalDirectoryObjectId,
                'GroupFilesHubPollGroupSite'
            );

            // Success
            if (createGroupSiteResponse.SiteStatus == GroupSiteStatus.Ready) {
                datapoint.addCustomProperty('PollingTimes', i + 1);
                datapoint.end();
                return createGroupSiteResponse;
            }

            // Failure
            if (
                createGroupSiteResponse.SiteStatus == GroupSiteStatus.NotFound ||
                createGroupSiteResponse.SiteStatus == GroupSiteStatus.Error
            ) {
                const error = new Error(
                    'SiteStatus is ' +
                        createGroupSiteResponse.SiteStatus.toString() +
                        '. Error message is ' +
                        createGroupSiteResponse.ErrorMessage
                );

                datapoint.addCustomProperty('PollingTimes', i + 1);
                datapoint.endWithError(DatapointStatus.ServerError, error);
                throw error;
            }

            // End with still provisioning
            if (i == MAX_POLLING_TIMES - 1) {
                datapoint.addCustomProperty(
                    'LastPollResponseStatus',
                    createGroupSiteResponse.SiteStatus.toString()
                );
            }
        } catch (error) {
            datapoint.endWithError(DatapointStatus.ServerError, getErrorFromObject(error));
            throw error;
        }

        await delay(POLL_DELAY_IN_MSEC);
    }

    const error = new Error('The maximum allowed polling times reached.');
    datapoint.endWithError(DatapointStatus.ServerError, error);
    throw error;
}
